import React, { useState, memo } from 'react';
import { ChevronDownIcon, ChevronUpIcon } from 'lucide-react';
import { ActionButtons } from './ActionButtons';
export function Itinerary() {
  const [expandedDay, setExpandedDay] = useState<number | null>(1);
  const [expandAll, setExpandAll] = useState(false);
  const itineraryData = [{
    day: 1,
    title: 'SINGAPORE / ZURICH',
    meals: '',
    description: "Assemble at the airport and depart for Zurich, Switzerland's financial centre.",
    image: ''
  }, {
    day: 2,
    title: 'ZURICH / BASEL / LUCERNE',
    meals: '(DINNER)',
    description: 'Arrive in Zurich and transfer to Basel for a brief city tour. Continue to Lucerne for dinner and overnight stay.',
    image: ''
  }, {
    day: 3,
    title: 'LUCERNE / MOUNT PILATUS',
    meals: '(BREAKFAST, DINNER)',
    description: "Visit Lucerne's Old Town and take a cable car ride up Mount Pilatus for panoramic views of the Alps.",
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/qFhteweMA3ASidTvG6poEN/image.png'
  }, {
    day: 4,
    title: 'LUCERNE / INTERLAKEN / JUNGFRAUJOCH',
    meals: '(BREAKFAST, DINNER)',
    description: "Travel to Interlaken and ascend to Jungfraujoch, the 'Top of Europe' at 3,454m above sea level.",
    image: 'https://images.unsplash.com/photo-1531366599837-ce0c0e17657c?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80'
  }, {
    day: 5,
    title: 'INTERLAKEN / ZERMATT',
    meals: '(BREAKFAST, DINNER)',
    description: 'Journey to the car-free alpine village of Zermatt, nestled at the foot of the iconic Matterhorn.',
    image: 'https://images.unsplash.com/photo-1565108757856-f19e0a88118c?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80'
  }, {
    day: 6,
    title: 'ZERMATT / GORNERGRAT / MONTREUX',
    meals: '(BREAKFAST)',
    description: 'Take the Gornergrat railway for spectacular views of the Matterhorn, then continue to Montreux on Lake Geneva.',
    image: 'https://images.unsplash.com/photo-1546972661-cf49a5962ffc?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80'
  }, {
    day: 7,
    title: 'MONTREUX / GENEVA / GRUYÈRES',
    meals: '(BREAKFAST, TRADITIONAL SWISS DINNER)',
    description: 'Visit Geneva and the charming medieval town of Gruyères, famous for its cheese production.',
    image: 'https://images.unsplash.com/photo-1589831494949-63e402cace9b?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80'
  }, {
    day: 8,
    title: 'GRUYÈRES / BERN / RHINE FALLS / ZURICH',
    meals: '(BREAKFAST, FAREWELL DINNER)',
    description: "Explore Bern's UNESCO-listed Old Town, visit Europe's largest waterfall at Rhine Falls, and return to Zurich.",
    image: 'https://images.unsplash.com/photo-1564501434027-35b3da297072?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80'
  }, {
    day: 9,
    title: 'ZURICH',
    meals: '(BREAKFAST)',
    description: 'Enjoy a guided tour of Zurich with free time for shopping and personal exploration.',
    image: 'https://images.unsplash.com/photo-1515488764276-beab7607c1e6?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80'
  }, {
    day: 10,
    title: 'IN-FLIGHT',
    meals: '(IN-FLIGHT MEALS)',
    description: 'Transfer to the airport for your return flight.',
    image: ''
  }, {
    day: 11,
    title: 'SINGAPORE',
    meals: '',
    description: 'Arrive in Singapore with fond memories of your Swiss adventure.',
    image: ''
  }];
  const toggleDay = (day: number) => {
    if (expandedDay === day) {
      setExpandedDay(null);
    } else {
      setExpandedDay(day);
    }
  };
  const toggleExpandAll = () => {
    setExpandAll(!expandAll);
    setExpandedDay(null);
  };
  return <section data-id="element-709">
      <div className="flex items-center justify-between mb-6" data-id="element-710">
        <h2 className="text-2xl font-bold text-gray-900" data-id="element-711">
          Day by Day Itinerary
        </h2>
        <button onClick={toggleExpandAll} className="text-sm font-medium text-blue-600 hover:text-blue-800 flex items-center" data-id="element-712">
          {expandAll ? 'Collapse All' : 'Expand All'}
        </button>
      </div>
      <div className="mb-6" data-id="element-713">
        <ActionButtons data-id="element-714" />
      </div>
      <div className="space-y-4" data-id="element-715">
        {itineraryData.map(day => <div key={day.day} className="border border-gray-200 rounded-lg overflow-hidden" data-id="element-716">
            <button onClick={() => toggleDay(day.day)} className="w-full flex items-center justify-between p-4 bg-gray-50 hover:bg-gray-100 text-left" data-id="element-717">
              <div className="flex items-center" data-id="element-718">
                <div className="bg-blue-600 text-white font-medium rounded-full w-8 h-8 flex items-center justify-center mr-3" data-id="element-719">
                  {day.day}
                </div>
                <div data-id="element-720">
                  <h3 className="font-medium text-gray-900" data-id="element-721">{day.title}</h3>
                  <p className="text-sm text-gray-600" data-id="element-722">{day.meals}</p>
                </div>
              </div>
              {expandAll || expandedDay === day.day ? <ChevronUpIcon size={20} className="text-gray-500" data-id="element-723" /> : <ChevronDownIcon size={20} className="text-gray-500" data-id="element-724" />}
            </button>
            {(expandAll || expandedDay === day.day) && <div className="p-4 border-t border-gray-200" data-id="element-725">
                <p className="text-gray-700 mb-4" data-id="element-726">{day.description}</p>
                {day.image && <img src={day.image} alt={`Day ${day.day}: ${day.title}`} className="w-full h-64 object-cover rounded-lg" data-id="element-727" />}
              </div>}
          </div>)}
      </div>
    </section>;
}